import { useUser } from 'contexts/UserContext'
import UserFormDetail from 'forms/User/UserFormDetail'
import useFetch from 'hooks/useFetch'
import { useToast } from 'hooks/useToast'
import PropTypes from 'prop-types'
import { useEffect, useState } from 'react'
import { ImSpinner9 } from 'react-icons/im'
import { LuMoveLeft } from 'react-icons/lu'
import { useLocation } from 'wouter'

export default function UserViewDetail({ params }) {
  const { showToast } = useToast()
  const { user } = useUser()
  const [, setLocation] = useLocation()

  // useFetch(): hook personalizado para realizar solicitudes GET, POST, PUT, DELETE
  const [fetchedUser, fetchUser] = useFetch()
  const [fetchedRoles, fetchRoles] = useFetch()
  const [updatedUser, updateUser] = useFetch()
  const [deletedUser, deleteUser] = useFetch()

  // useState()
  const [roles, setRoles] = useState(null)

  // Variables:
  const isNew = params?.id === 'new'
  const [fields, setFields] = useState({
    id: 0,
    username: '',
    email: '',
    first_name: '',
    last_name: '',
    profile_picture: '',
    role_id: 2,
    is_active: 1,
    password: '',
    password_confirmation: ''
  })

  // CRUD: GET
  useEffect(() => {
    const fetchData = async () => {
      try {
        const rolesApiCall = {
          url: 'roles',
          method: 'GET',
          messageKo: '¡Error al recoger Roles!'
        }

        const userApiCall = !isNew
          ? {
              url: `users/${params.id}`,
              method: 'GET',
              messageKo: '¡Error al recoger Usuario!'
            }
          : null

        const apiCalls = [fetchRoles(rolesApiCall)]
        if (userApiCall) apiCalls.push(fetchUser(userApiCall))

        await Promise.all(apiCalls)
      } catch (error) {
        console.error('Error fetching data:', error)
      }
    }

    fetchData()
  }, [])

  // Escuchar GET
  useEffect(() => {
    if (fetchedUser.data) {
      setFields({
        id: fetchedUser.data.id,
        username: fetchedUser.data.username,
        email: fetchedUser.data.email,
        first_name: fetchedUser.data.first_name,
        last_name: fetchedUser.data.last_name,
        profile_picture: fetchedUser.data.profile_picture,
        role_id: fetchedUser.data.role_id,
        is_active: fetchedUser.data.is_active,
        password: '',
        password_confirmation: ''
      })
    }

    if (fetchedUser.error) {
      setLocation('/page-not-found')
    }
  }, [fetchedUser.data, fetchedUser.error])

  // Escuchar GET
  useEffect(() => {
    if (fetchedRoles.data) {
      setRoles(fetchedRoles.data)
    }
  }, [fetchedRoles.data])

  // CRUD: POST
  const handleSubmit = async (values) => {
    let url = `users/${user.id}`
    let method = 'POST'

    // Si no es un nuevo usuario, actualizar datos con PUT
    if (!isNew) {
      method = 'PUT'
      url += `/${params.id}`

      // Si la contraseña está vacía, no se envía
      if (values.password === '') {
        values.password = null
      }
    }

    const apiCallPost = {
      url,
      method,
      body: values
    }
    await updateUser(apiCallPost)
  }

  // Mostrar mensaje API: POST / PUT (notificación de éxito o error)
  useEffect(() => {
    if (updatedUser.isCalled) {
      if (updatedUser.message) {
        showToast(updatedUser.message, 'success')
        setLocation('/users/grid')
      }

      if (updatedUser.error) {
        showToast(updatedUser.error, 'error')
      }
    }
  }, [updatedUser.loading])

  // CRUD: DELETE
  const handleDelete = async (id) => {
    const apiCallDelete = {
      url: `users/${user.id}/${id}`,
      method: 'DELETE'
    }
    await deleteUser(apiCallDelete)
  }

  // Mostrar mensaje API: DELETE (notificación de éxito o error)
  useEffect(() => {
    if (deletedUser.isCalled) {
      if (deletedUser.message) {
        showToast(deletedUser.message, 'success')
        setLocation('/users/grid')
      }

      if (deletedUser.error) {
        showToast(deletedUser.error, 'error')
      }
    }
  }, [deletedUser.loading])

  return isNew || (!isNew && fields.id !== 0) ? (
    <>
      <div className="sm:flex sm:items-start sm:justify-between">
        <div className="flex items-start gap-x-3">
          <h2 className="text-lg font-medium text-gray-800 dark:text-white">
            Usuario {fields?.id !== 0 ? '#' + fields?.id : 'nou'}
          </h2>
        </div>

        <div className="flex items-center mt-4 sm:mt-0 gap-x-4">
          <button
            title="Volver"
            type="button"
            className="flex items-center justify-center w-1/2 px-5 py-2 text-sm text-white capitalize transition-colors duration-200 border rounded-sm bg-accent border-accent sm:w-36 gap-x-2 enabled:hover:bg-white enabled:hover:text-accent dark:bg-gray-900 dark:text-gray-200 dark:border-gray-700 dark:enabled:hover:bg-gray-800 disabled:opacity-30 focus:ring-opacity-20 focus:outline-none focus:ring focus:ring-accent focus:border-accent dark:focus:border-accent"
            onClick={() => setLocation('/users/grid')}
          >
            <LuMoveLeft size={20} />
            <span>Volver</span>
          </button>
        </div>
      </div>

      <UserFormDetail
        id={params?.id}
        isNew={isNew}
        user={user}
        fields={fields}
        roles={roles}
        handleSubmit={handleSubmit}
        handleDelete={handleDelete}
      />
    </>
  ) : (
    <div className="flex items-center content-center justify-center w-full h-full">
      <p
        className="flex flex-col-reverse items-center justify-center h-full font-bold dark:text-[#F5F5F5] text-gray-700"
        title="Cargando..."
      >
        <ImSpinner9 size={70} className="animate-spin" />
      </p>
    </div>
  )
}

UserViewDetail.propTypes = {
  params: PropTypes.any
}
